'use strict';

var React = require('react');
var IconBase = require('./dist/IconBase.js');

module.exports = function (props) {
    return React.createElement(IconBase, Object.assign({ viewBox: '0 0 1024 1024' }, props, {
        style: { width: '1em' }
    }), React.createElement(
        'g',
        null,
        React.createElement('path', { d: 'M448 576v-572.024c-252.562 31.496-448 246.93-448 508.024 0 282.77 229.23 512 512 512 261.094 0 476.53-195.438 508.026-448h-572.026zM809.58 846.888c-82.014 72.942-187.696 113.112-297.58 113.112-60.508 0-119.172-11.836-174.362-35.18-53.34-22.56-101.256-54.874-142.42-96.038-41.166-41.162-73.478-89.080-96.038-142.42-23.344-55.19-35.18-113.854-35.18-174.362 0-109.884 40.17-215.566 113.112-297.578 55.866-62.816 127.634-108.242 206.888-131.85v557.428h557.43c-23.61 79.256-69.036 151.022-131.85 206.888zM512 0c282.77 0 512 229.23 512 512h-512v-512z' })
    ));
};